import { getSessionDetail } from '../ajax';
import { renderSessionDetailPopup } from '../render';
import { visoStore } from '../store';
import { updateSessionButtons } from '../utilities';

export function handleClickItemListView() {
	const container = document.getElementById('viso-list');
	if (!container) return;

	container.addEventListener('click', (e) => {
		const item = e.target.closest('[data-action="send-link"]');
		if (item) handleSendLink(item);
	});
}

export async function handleSendLink(node) {
	if (!node) return;

	const sessionId = node.dataset.sessionId;
	if (!sessionId) return;

	let session = visoStore.getCurrentSession();
	if (!session) {
		session = await getSessionDetail(sessionId);
	}

	if (!session) return;

	renderSessionDetailPopup(session);
	updateSessionButtons(session);
	wpcore.showPopup('session-detail');
}
